var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNivel4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 85,
    viewBox: "0 0 61 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.316 30.156C60.316 46.8075 46.818 60.314 30.158 60.314C13.498 60.314 0 46.8075 0 30.156C0 13.5045 13.5065 -0.00195312 30.158 -0.00195312C46.8095 -0.00195312 60.316 13.496 60.316 30.1475V30.156Z",
    fill: "url(#paint0_linear_1266_2991)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4893 44.1236C48.4893 54.2471 30.1548 84.2861 30.1548 84.2861C30.1548 84.2861 11.8203 54.2556 11.8203 44.1236C11.8203 33.9916 20.0313 25.7891 30.1548 25.7891C40.2783 25.7891 48.4893 34.0001 48.4893 44.1236Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4893 36.0591C48.4893 46.1826 30.1548 76.2216 30.1548 76.2216C30.1548 76.2216 11.8203 46.1911 11.8203 36.0591C11.8203 25.9271 20.0313 17.7246 30.1548 17.7246C40.2783 17.7246 48.4893 25.9356 48.4893 36.0591Z",
    fill: "url(#paint1_linear_1266_2991)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2157 30.1587C56.2157 44.5492 44.5452 56.2197 30.1547 56.2197C15.7642 56.2197 4.09375 44.5492 4.09375 30.1587C4.09375 15.7682 15.7642 4.09766 30.1547 4.09766C44.5452 4.09766 56.2157 15.7682 56.2157 30.1587Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2515 38.2819C22.0819 38.2819 21.0347 37.9963 20.1099 37.4251C19.1851 36.8403 18.4575 35.9971 17.9271 34.8955C17.3967 33.7939 17.1315 32.4611 17.1315 30.8971C17.1315 29.3331 17.3967 28.0003 17.9271 26.8987C18.4575 25.7971 19.1851 24.9607 20.1099 24.3895C21.0347 23.8047 22.0819 23.5123 23.2515 23.5123C24.4347 23.5123 25.4819 23.8047 26.3931 24.3895C27.3179 24.9607 28.0455 25.7971 28.5759 26.8987C29.1063 28.0003 29.3715 29.3331 29.3715 30.8971C29.3715 32.4611 29.1063 33.7939 28.5759 34.8955C28.0455 35.9971 27.3179 36.8403 26.3931 37.4251C25.4819 37.9963 24.4347 38.2819 23.2515 38.2819ZM23.2515 35.4871C23.8091 35.4871 24.2919 35.3307 24.6999 35.0179C25.1215 34.7051 25.4479 34.2087 25.6791 33.5287C25.9239 32.8487 26.0463 31.9715 26.0463 30.8971C26.0463 29.8227 25.9239 28.9455 25.6791 28.2655C25.4479 27.5855 25.1215 27.0891 24.6999 26.7763C24.2919 26.4635 23.8091 26.3071 23.2515 26.3071C22.7075 26.3071 22.2247 26.4635 21.8031 26.7763C21.3951 27.0891 21.0687 27.5855 20.8239 28.2655C20.5927 28.9455 20.4771 29.8227 20.4771 30.8971C20.4771 31.9715 20.5927 32.8487 20.8239 33.5287C21.0687 34.2087 21.3951 34.7051 21.8031 35.0179C22.2247 35.3307 22.7075 35.4871 23.2515 35.4871ZM30.814 35.0383V32.8147L37.546 23.7571H41.014L34.4248 32.8147L32.8132 32.3455H44.0536V35.0383H30.814ZM38.5048 38.0371V35.0383L38.6068 32.3455V29.6731H41.728V38.0371H38.5048Z",
    fill: "#808080"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1266_2991",
    x1: 8.8315,
    y1: 51.4825,
    x2: 51.4845,
    y2: 8.83805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A7A7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1266_2991",
    x1: 13.6308,
    y1: 59.6976,
    x2: 46.6788,
    y2: 26.6581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNivel4);
export default __webpack_public_path__ + "static/media/Nivel4.53c4a4f7105fdebaf28ac50120428367.svg";
export { ForwardRef as ReactComponent };